import { IOption } from '@cbridge-utils/options';
import { IAutocompleteValueType } from '../AutocompleteFieldControl.interface';

function isOption(item: IAutocompleteValueType): item is IOption {
  return item instanceof Object;
}

const getValue = (value: IAutocompleteValueType) => {
  if (isOption(value)) {
    return value.value;
  }

  return value;
};

export const isOptionEqualToValue= (option: IAutocompleteValueType, value: IAutocompleteValueType) =>
  getValue(option) === getValue(value);
